import Typography from '@mui/material/Typography';
import Modal from "antd/lib/modal/Modal";
import AntTypography from "antd/lib/typography";
import Tag from "antd/lib/tag";

import { IconCloudStorm, IconAlertTriangle, IconUser } from "@tabler/icons-react";

import styles from "./confirmation-modal.module.css";

const { Text } = AntTypography;

const TEST_MODE_EMAIL = process.env.REACT_APP_TEST_MODE_EMAIL;

export default function ConfirmationModal({ showConfirmModal, handleSubmitFinal, setShowConfirmModal, isTestMode, selectedSites, selectedRegion, customMessage }) {
    return (
        <Modal
        title={
          <div className={styles.modalConfirmHeader}>
            <IconCloudStorm size={24} />
            <Typography variant="h6">Confirm Storm Strategy</Typography>
          </div>
        }
        open={showConfirmModal}
        onOk={handleSubmitFinal}
        onCancel={() => setShowConfirmModal(false)}
        okText="Yes, send strategy"
        cancelText="No, review again"
        className={styles.confirmModal}
        width={600}
        getContainer={false}
      >
        <div className={styles.confirmContent}>
          <div className={styles.confirmMessage}>
            <IconAlertTriangle size={20} className={styles.confirmIcon} />
            <Typography>
              Are you sure you want to send this storm strategy to {selectedSites.length} sites?
              {isTestMode && (
                <Text type="warning" style={{ display: 'block', marginTop: 8 }}>
                  Test Mode: All emails will be sent to {TEST_MODE_EMAIL}
                </Text>
              )}
            </Typography>
          </div>

          <div className={styles.confirmDetails}>
            <div className={styles.confirmSection}>
              <Text strong>Region</Text>
              <div className={styles.confirmValue}>{selectedRegion}</div>
            </div>

            <div className={styles.confirmSection}>
              <Text strong>Selected Sites and Contacts</Text>
              <div className={styles.confirmSites}>
                {selectedSites.map(site => (
                  <div key={site.site_id} className={styles.confirmSiteDetails}>
                    <Tag className={styles.confirmSiteTag}>
                      {site.site_name}
                    </Tag>
                    <div className={styles.confirmContacts}>
                      {isTestMode ? (
                        <div className={styles.confirmContact}>
                          <IconUser size={14} />
                          <span>Test Mode</span>
                          <span className={styles.confirmEmail}>{TEST_MODE_EMAIL}</span>
                        </div>
                      ) : site.contacts?.length > 0 ? (
                        site.contacts.map((contact, idx) => (
                          <div key={idx} className={styles.confirmContact}>
                            <IconUser size={14} />
                            {contact.first_name === 'Default' ? (
                              <span style={{ color: '#d48806' }}>Fallback Contact</span>
                            ) : (
                              <span>{contact.first_name} {contact.last_name}</span>
                            )}
                            <span className={styles.confirmEmail}>{contact.email}</span>
                          </div>
                        ))
                      ) : (
                        <div className={styles.confirmContact}>
                          <IconUser size={14} />
                          <span style={{ color: '#d48806' }}>Fallback Contact</span>
                          <span className={styles.confirmEmail}>{TEST_MODE_EMAIL}</span>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className={styles.confirmSection}>
              <Text strong>Message</Text>
              <div className={styles.confirmMessageBox}>
                {customMessage}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    )
}